// tslint:disable: max-line-length
import { getComparedToAverageClassStyle } from './../helpers/getComparedToAverageStyle';
import { groupBy } from 'lodash';
import {
  CreateDataByIndexedDB,
  GetAllDataByIndexedDB,
} from './../indexed/index';
import { userHotelDetails } from './../helpers/handleBrandAndHotelData';
import axiosInstance from './../helpers/interceptor';

export const hotelBenchMarking = async (
  selectedAssessment,
  performanceClassification
) => {
  const { selectedHotel, selectedBrand } = userHotelDetails();
  if (performanceClassification && performanceClassification === 'all') {
    performanceClassification = undefined;
  }
  let dataD: any = [];
  const OfflineData = await GetAllDataByIndexedDB(
    `${Env.API_URL}/customer/hotel-dashboard/${selectedHotel}/benchmark-by-category?&brandId=${selectedBrand}&toDate=${selectedAssessment}&isClientApp=true${performanceClassification ? '&performanceClassifier=' + performanceClassification : ''}`,
    selectedHotel
  );
  if (OfflineData) {
    dataD = OfflineData;
  } else {
    const { data } = await axiosInstance.get(
      `${Env.API_URL}/customer/hotel-dashboard/${selectedHotel}/benchmark-by-category?&brandId=${selectedBrand}&toDate=${selectedAssessment}&isClientApp=true${performanceClassification ? '&performanceClassifier=' + performanceClassification : ''}`
    );
    dataD = data;
    CreateDataByIndexedDB(
      `${Env.API_URL}/customer/hotel-dashboard/${selectedHotel}/benchmark-by-category?&brandId=${selectedBrand}&toDate=${selectedAssessment}&isClientApp=true${performanceClassification ? '&performanceClassifier=' + performanceClassification : ''}`,
      data,
      selectedHotel
    );
  }
  const { scores } = dataD;
  const trends = scores.map((score) => {
    return {
      name: score.categoryName,
      val: score.score,
      lineVal: score.rank,
      total: score.total,
      intent: getComparedToAverageClassStyle(
        score.average ? score.score - score.average : undefined
      ),
    };
  });

  return trends;
};
export const benchmarkCustom = async (
  customNumber,
  selectedAssessment,
  performanceClassification?: string
) => {
  const { selectedHotel, selectedBrand } = userHotelDetails();
  if (performanceClassification && performanceClassification === 'all') {
    performanceClassification = undefined;
  }

  let dataD: any = [];
  const OfflineData = await GetAllDataByIndexedDB(
    `${Env.API_URL}/customer/hotel-dashboard/${selectedHotel}/custom-benchmark-by-category?&brandId=${selectedBrand}&isBenchmarkPage=true&scoreNumber=${customNumber}&toDate=${selectedAssessment}&isClientApp=true${performanceClassification ? '&performanceClassifier=' + performanceClassification : ''}`,
    selectedHotel
  );
  if (OfflineData) {
    dataD = OfflineData;
  } else {
    const { data } = await axiosInstance.get(
      `${Env.API_URL}/customer/hotel-dashboard/${selectedHotel}/custom-benchmark-by-category?&brandId=${selectedBrand}&isBenchmarkPage=true&scoreNumber=${customNumber}&toDate=${selectedAssessment}&isClientApp=true${performanceClassification ? '&performanceClassifier=' + performanceClassification : ''}`
    );
    dataD = data;
    CreateDataByIndexedDB(
      `${Env.API_URL}/customer/hotel-dashboard/${selectedHotel}/custom-benchmark-by-category?&brandId=${selectedBrand}&isBenchmarkPage=true&scoreNumber=${customNumber}&toDate=${selectedAssessment}&isClientApp=true${performanceClassification ? '&performanceClassifier=' + performanceClassification : ''}`,
      data,
      selectedHotel
    );
  }
  const { scores } = dataD;
  const count = scores.filter((o) => o.categoryType === 'category').length;
  let trends: any = [];
  if (count > 1) {
    trends = scores
      .filter(
        (sc) => sc.categoryType === 'category' || sc.categoryType === 'overall'
      )
      .map((score) => {
        return {
          name: score.categoryName,
          val: score.score,
          lineVal: score.rank,
          total: score.total,
          intent: 'success',
        };
      });
  } else {
    trends = scores
      .filter(
        (sc) =>
          sc.categoryType === 'subCategory' || sc.categoryType === 'overall'
      )
      .map((score) => {
        return {
          name: score.categoryName,
          val: score.score,
          lineVal: score.rank,
          total: score.total,
          intent: 'success',
        };
      });
  }
  return {
    scores,
    trends,
  };
};

export const hotelScoresByDepartmentBenchmarking = async (
  selectedAssessment,
  standard,
  performanceClassification,
  selectedCompset
) => {
  const { selectedHotel, selectedBrand } = userHotelDetails();
  if (performanceClassification && performanceClassification === 'all') {
    performanceClassification = undefined;
  }
  let condition = '';

  if (standard !== 'LQA') {
    standard = 'custom' + standard;
  }

  if (performanceClassification) {
    condition += `&performanceClassification=${performanceClassification}`;
  }

  let compset = '';
  if (selectedCompset !== '0') {
    compset = '&compSetNumber=' + selectedCompset;
  }

  let dataD: any = [];
  const OfflineData = await GetAllDataByIndexedDB(
    `${Env.API_URL}/customer/hotel-benchmarking/${selectedHotel}/benchmarks?&view=category&hotelTypes=City&hotelTypes=Resort&standard=${standard}&brandId=${selectedBrand}&toDate=${selectedAssessment}${condition}${compset}&isClientApp=true-Benchmarking`,
    selectedHotel
  );
  if (OfflineData) {
    dataD = OfflineData;
  } else {
    const { data } = await axiosInstance.get(
      `${Env.API_URL}/customer/hotel-benchmarking/${selectedHotel}/benchmarks?&view=category&hotelTypes=City&hotelTypes=Resort&standard=${standard}&brandId=${selectedBrand}&toDate=${selectedAssessment}${condition}${compset}&isClientApp=true`
    );
    dataD = data;
    CreateDataByIndexedDB(
      `${Env.API_URL}/customer/hotel-benchmarking/${selectedHotel}/benchmarks?&view=category&hotelTypes=City&hotelTypes=Resort&standard=${standard}&brandId=${selectedBrand}&toDate=${selectedAssessment}${condition}${compset}&isClientApp=true-Benchmarking`,
      data,
      selectedHotel
    );
  }
  return dataD;
};

export const AssessmentSummaryAPI = async (
  selectedDate,
  standard = 'LQA',
  performanceClassification = undefined
) => {
  const { selectedHotel } = userHotelDetails();
  if (standard !== 'LQA') {
    standard = 'custom' + standard;
  }

  let view = `view=category`;

  if (performanceClassification) {
    view = `view=performance&performanceClassification=${performanceClassification}`;
  }
  let dataD: any = [];
  const OfflineData = await GetAllDataByIndexedDB(
    `${Env.API_URL}/customer/hotel-assessment-summary/${selectedHotel}?&${view}&standard=${standard}&toDate=${selectedDate}&isClientApp=true`,
    selectedHotel
  );
  if (OfflineData) {
    dataD = OfflineData;
  } else {
    const { data } = await axiosInstance.get(
      `${Env.API_URL}/customer/hotel-assessment-summary/${selectedHotel}?&${view}&standard=${standard}&toDate=${selectedDate}&isClientApp=true`
    );
    dataD = data;
    CreateDataByIndexedDB(
      `${Env.API_URL}/customer/hotel-assessment-summary/${selectedHotel}?&${view}&standard=${standard}&toDate=${selectedDate}&isClientApp=true`,
      dataD,
      selectedHotel
    );
  }
  const modData = [...dataD.data];
  const groupedData = groupBy(modData, 'parentId');

  const categories = modData.filter((m) => m.categoryType === 'category');
  const realData = categories.map((category) => {
    if (groupedData[category.id]) {
      category.subCategory = groupedData[category.id];
    }
    return category;
  });
  return { ...dataD, data: realData };
};
